/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-23 09:07:14
 * @LastEditors: jyf
 * @LastEditTime: 2022-08-12 13:37:46
 */

import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import login from './modules/login';
import bread from './modules/bread';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        blobUrl: '',
        ossBucket: '', //ali-oss
        asyncRouterMap: [],
        isFirst: true,
        mesNum: 0,
        /**发运数 */
        datavShipNum:0
    },
    getters:{
        datavShipNum: (getters) => getters.datavShipNum,
    },
    mutations: {
        updateNumber(state, vm) {
            state.mesNum ++
        },
        updateShip(state,data){
            state.datavShipNum = data;
        }
    },
    actions: {
        async getMessage({ state, dispatch, commit, getters, rootGetters }) {
            commit('updateNumber');
        },
        async getShip({ state, dispatch, commit, getters, rootGetters },data) {
            commit('updateShip',data);
        },
    },
    modules: {
        app,
        login,
        bread,
    }
});

export default store;
